export type LeasingSearchCriteriaValue = string | boolean | Array<string | number>;
export type LeasingSearchCriteria = Record<string, LeasingSearchCriteriaValue>;

const DEFAULT_VEHICLE_TYPE = 'Car';
const DEFAULT_FINANCE_TYPE = 'Personal';
const DEFAULT_STOCK_STATUS = false;

export const createBaseLeasingSearchCriteria = (): LeasingSearchCriteria => {
    return {
        vehicle_type: DEFAULT_VEHICLE_TYPE,
        finance_type: DEFAULT_FINANCE_TYPE,
        stock_status: DEFAULT_STOCK_STATUS,
    };
};

export const setStockStatus = (
    criteria: LeasingSearchCriteria,
    isInStock: boolean,
): LeasingSearchCriteria => {
    criteria.stock_status = isInStock;
    return criteria;
};

export const setManufacturer = (
    criteria: LeasingSearchCriteria,
    manufacturer: string,
): LeasingSearchCriteria => {
    const normalizedValue = String(manufacturer || '').trim();
    if (!normalizedValue) {
        return criteria;
    }
    criteria.manufacturer = normalizedValue;
    return criteria;
};

export const setStringArrayFacet = (
    criteria: LeasingSearchCriteria,
    criteriaKey: string,
    selectedValues: string[],
): LeasingSearchCriteria => {
    if (!criteriaKey || selectedValues.length === 0) {
        return criteria;
    }
    criteria[criteriaKey] = selectedValues.map((value) => String(value));
    return criteria;
};

export const setNumberArrayFacet = (
    criteria: LeasingSearchCriteria,
    criteriaKey: string,
    selectedValues: string[],
): LeasingSearchCriteria => {
    if (!criteriaKey || selectedValues.length === 0) {
        return criteria;
    }
    criteria[criteriaKey] = selectedValues.map((value) => Number(value));
    return criteria;
};
